/**
 * @Copyright (c) 2021 DigiNet
 * @author NHATLONG
 * @create 25/6/2021
 * @Example
 */

import React, { useState, useRef, useEffect, useMemo } from 'react';
import ActionToolbar from "../../../common/toolbar/action-toolbar";
import { Button, TabContainer, TabHeader, TabItem, Dropdown, DatePicker, TextInput } from 'diginet-core-ui/components';
import Config from '../../../../config/index';
import GridTabContent from './gridTabContent';
import Filter from '../../../filter/filter';
import moment from 'moment';
import _ from 'lodash';
import { Row, Col } from 'react-bootstrap';
import ModalW05F0008 from './modalW05F0008';
import { useDispatch } from 'react-redux';
import * as W05F0008Actions from '../../../../redux/W0X/W05F0008/W05F0008_actions';
import * as generalActions from '../../../../redux/general/general_actions';
import { browserHistory } from 'react-router';
import { LoadPanel } from "devextreme-react";
import ModalApproveW05F0008 from './modalApproveW05F0008';


const W05F0008 = (props) => {
    const dispatch = useDispatch();
    const [tab, setTab] = useState(0);
    const dataDayByCombo = [
        {
            id: 1,
            fieldName: Config.lang("Hom_nay"),
            dateFrom: moment().format("YYYY-MM-DD"),
            dateTo: moment().format("YYYY-MM-DD")
        },
        {
            id: 2,
            fieldName: Config.lang("Hom_qua"),
            dateFrom: moment().subtract(1, 'day').format("YYYY-MM-DD"),
            dateTo: moment().subtract(1, 'day').format("YYYY-MM-DD")
        },
        {
            id: 3,
            fieldName: Config.lang("Tuan_nay"),
            dateFrom: moment().startOf('week').format("YYYY-MM-DD"),
            dateTo: moment().endOf('week').format("YYYY-MM-DD")
        },
        {
            id: 4,
            fieldName: Config.lang("Tuan_truoc"),
            dateFrom: moment().subtract(1, 'week').startOf('week').format("YYYY-MM-DD"),
            dateTo: moment().subtract(1, 'week').endOf('week').format("YYYY-MM-DD")
        },
        {
            id: 5,
            fieldName: Config.lang("Thang_nay"),
            dateFrom: moment().startOf("month").format("YYYY-MM-DD"),
            dateTo: moment().endOf("month").format("YYYY-MM-DD")
        },
        {
            id: 6,
            fieldName: Config.lang("Thang_truoc"),
            dateFrom: moment().subtract(1, 'months').startOf("month").format("YYYY-MM-DD"),
            dateTo: moment().subtract(1, 'months').endOf("month").format("YYYY-MM-DD")
        },
        {
            id: 7,
            fieldName: Config.lang("Nam_nay"),
            dateFrom: moment().startOf("year").format("YYYY-MM-DD"),
            dateTo: moment().endOf("year").format("YYYY-MM-DD")
        },
        {
            id: 8,
            fieldName: Config.lang("Nam_truoc"),
            dateFrom: moment().subtract(1, 'years').startOf("year").format("YYYY-MM-DD"),
            dateTo: moment().subtract(1, 'years').endOf("year").format("YYYY-MM-DD")
        },
        {
            id: 9,
            fieldName: Config.lang("Chon_thoi_gian"),
            dateFrom: moment().format("YYYY-MM-DD"),
            dateTo: moment().format("YYYY-MM-DD")
        },
    ];
    const [formData, setFormData] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [permission, setPermission] = useState(false);
    const [loading, setLoading] = useState(false);

    const [openModalApprove, setOpenModalApprove] = useState(false);
    const itemApprove = useRef(null);
    const [approvePermission, setApprovePermission] = useState(0);

    const filter = useRef({
        StrSearch: "",
        selectedDate: 7,
        DateFrom: moment().startOf("year").format("YYYY-MM-DD"),
        DateTo: moment().endOf("year").format("YYYY-MM-DD"),
        SubContractNo: '',
        ContractNo: '',
        EmployeeID: '',
        limit: 20,
        skip: 0
    });

    const [showFormItem, setShowFormItem] = useState(false);
    const [flag, setFlag] = useState(false);

    const [cbEmployee, setCbEmployee] = useState({ total: 0, rows: [] });
    const filterCboEmployees = useRef({ StrSearch: "", skip: 0, limit: 10 });

    const timer = useRef(null);
    const refDropdown = useRef(null);

    const loadPermission = () => {
        dispatch(generalActions.getPermission(["W05F0008", "W05F2008"], (isPer) => {
            if (isPer.length > 0) {
                setPermission(isPer[0].Permission);
                setApprovePermission(isPer[1].Permission);
            }
        }));
    };

    useEffect(() => {
        loadPermission();
        /* eslint-disable */
    }, [])

    useEffect(() => {
        loadForm();
        /* eslint-disable */
    }, [tab])

    const loadForm = () => {
        const IsApprove = tab - 1 < 0 ? '' : tab - 1;
        const params = { ...filter.current, IsApprove };
        setLoading(true);
        dispatch(W05F0008Actions.loadForm(params, (error, data) => {
            if (error) {
                let message = error.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show("INFO", message);
                setLoading(false);
                return false;
            }
            setFormData(data);
            setLoading(false);
        }))
    }

    const showFormSearchDay = (key, data) => {
        if (!key || !data || !data.value || _.isEmpty(dataDayByCombo)) return false;
        const checked = dataDayByCombo.find(value => value.id === data.value);
        const showFormItem = checked.id === 9; // 9 Là tùy Chọn Ngày
        filter.current.selectedDate = data.value;
        filter.current.DateFrom = checked.dateFrom;
        filter.current.DateTo = checked.dateTo;
        setShowFormItem(showFormItem);
    };

    const handleFilterChange = (key, data) => {
        if (!key) return false;
        switch (key) {
            case "id":
                showFormSearchDay(key, data);
                break;
            case "dateFrom":
                filter.current.DateFrom = data.value;
                break;
            case "dateTo":
                filter.current.DateTo = data.value;
                break;
            case "SubContractNo":
            case "ContractNo":
                filter.current[key] = data.target.value;
                break;
            case "EmployeeID":
                filter.current.EmployeeID = data.value;
                break;
            default:
                break;
        }
        setFlag(!flag);
    }

    const renderFilters = () => {
        return (
            <Filter
                onTextChanged={onSearch}
                placeholder={Config.lang("Noi_dung_can_tim_kiem")}
                onOpenLoaded={onLoadDataFilter}
                isUseDDCore
                dropdownProps={{
                    ref: ref => refDropdown.current = ref
                }}
                renderFilter={() => {
                    return (
                        <div>
                            <Dropdown
                                viewType="outlined"
                                label={Config.lang("Thoi_gian")}
                                dataSource={dataDayByCombo}
                                onChange={e => handleFilterChange("id", e)}
                                valueExpr={"id"}
                                displayExpr={"fieldName"}
                                style={{ margin: 0 }}
                                value={filter.current.selectedDate || 7}
                            />
                            {showFormItem && <Row>
                                <Col xs={12} sm={6} md={6} lg={6} >
                                    <div className={"display_row align-center"}>
                                        <DatePicker
                                            label={Config.lang("Tu")}
                                            style={{ margin: 0 }}
                                            viewType="outlined"
                                            max={filter.current.DateTo}
                                            displayFormat="DD/MM/YYYY"
                                            width={"100%"}
                                            value={filter.current.DateFrom}
                                            onChange={e => handleFilterChange("dateFrom", e)}
                                        />
                                    </div>
                                </Col>
                                <Col xs={12} sm={6} md={6} lg={6}>
                                    <div className={"display_row align-center"}>
                                        <DatePicker
                                            label={Config.lang("Den")}
                                            style={{ margin: 0 }}
                                            viewType="outlined"
                                            min={filter.current.DateFrom}
                                            displayFormat="DD/MM/YYYY"
                                            width={"100%"}
                                            value={filter.current.DateTo}
                                            onChange={e => handleFilterChange("dateTo", e)}
                                        />
                                    </div>
                                </Col>
                            </Row>}
                            <TextInput
                                label={Config.lang('So_phu_luc')}
                                style={{ margin: 0 }}
                                viewType="outlined"
                                value={filter.current.SubContractNo}
                                onChange={e => handleFilterChange('SubContractNo', e)}
                            />
                            <TextInput
                                label={Config.lang('So_hop_dong')}
                                style={{ margin: 0 }}
                                viewType="outlined"
                                value={filter.current.ContractNo}
                                onChange={e => handleFilterChange('ContractNo', e)}
                            />
                            <Dropdown
                                viewType="outlined"
                                label={Config.lang("Nguoi_lap")}
                                dataSource={cbEmployee.rows}
                                total={cbEmployee.total}
                                limit={filterCboEmployees.current.limit}
                                skip={filterCboEmployees.current.skip}
                                displayExpr={"{EmployeeID} - {EmployeeName}"}
                                keyExpr={"EmployeeID"}
                                valueExpr={"EmployeeID"}
                                onChange={e => handleFilterChange("EmployeeID", e)}
                                value={filter.current.EmployeeID}
                                onLoadMore={() => {
                                    filterCboEmployees.current.skip = filterCboEmployees.current.skip + filterCboEmployees.current.limit;
                                    getCboEmployees();
                                }}

                            />
                            <div className="display_row align-center valign-middle">
                                <Button startIcon="search" size="medium" viewType="outlined" color='primary' label={Config.lang("Tim_kiem")} onClick={onFilter} />
                            </div>
                        </div>
                    );
                }}
            />
        );
    };

    const onLoadDataFilter = () => {
        getCboEmployees();
    };

    const getCboEmployees = () => {
        dispatch(W05F0008Actions.getCboEmployees(filterCboEmployees.current, (error, data) => {
            if (error) {
                let message = error.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show("INFO", message);
                return false;
            }
            const rows = filterCboEmployees.current.skip <= 0 ? data.rows : cbEmployee.rows.length <= 0 ? data.rows : cbEmployee.rows.concat(data.rows);
            setCbEmployee({ rows: rows, total: data.total });
        }))
    }

    const onSearch = (e) => {
        const value = e.target.value;
        if (timer.current) clearTimeout(timer.current);
        timer.current = setTimeout(() => {
            filter.current.StrSearch = value;
            filter.current.skip = 0;
            filter.current.limit = 20;
            loadForm();
        }, 300)
    };

    const onFilter = () => {
        loadForm();
        refDropdown.current.close();
    }

    const onOpenModal = () => {
        setOpenModal(!openModal);
    }

    const onChangePage = (page) => {
        filter.current.skip = page * filter.current.limit;
        loadForm();
    };

    const onChangePerPage = (perPage) => {
        filter.current.skip = 0;
        filter.current.limit = perPage;
        loadForm();
    };

    const onCheck = (params, mode, item) => {
        dispatch(W05F0008Actions.onCheckEdit(params, (error, dataU) => {
            if (error) {
                let message = error.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show("INFO", message);
                return false;
            }
            if (dataU.Status !== 1) {
                let message = Config.lang(`Phu_luc_da_duoc_duyet_ban_khong_duoc_${mode === 'edit' ? 'sua' : 'xoa'}`);
                if (mode === "approve") {
                    message = Config.lang("Phu_luc_da_duoc_duyet");
                }
                Config.popup.show("INFO", message);
            } else {
                switch (mode) {
                    case "delete":
                        if (dataU.Status === 1) {
                            Config.popup.show(
                                "YES_NO",
                                Config.lang("Ban_co_chac_muon_xoa?"),
                                () => {
                                    onDelete(params, item);
                                }
                            );
                        }
                        break;
                    default:
                        browserHistory.push({
                            pathname: Config.getRootPath() + 'W05F0009',
                            state: params
                        });
                        break;
                }
            }
        }));
    };

    const onOpenModalAprrove = (item) => {
        setOpenModalApprove(!openModalApprove);
        itemApprove.current = item?.data;
    }

    const onDelete = (params, item) => {
        dispatch(W05F0008Actions.onDelete(params, (error, data) => {
            if (error) {
                let message = error.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show("INFO", message);
                return false;
            }
            item.component.deleteRow(item.rowIndex);
            const _formData = { ...formData };
            _formData.approves.map(rs => {
                if (rs.IsApprove === '' || rs.IsApprove === item.data.IsApprove) {
                    rs.Num--;
                }
                return rs;
            });
            setFormData(_formData);
            Config.notify.show("success", Config.lang("Xoa_thanh_cong"), 2000);
        }))
    };

    const approveTotal = useMemo(() => {
        const tab1 = formData?.approves.find(rs => rs.IsApprove === '')?.Num ?? 0;
        const tab2 = formData?.approves.find(rs => parseInt(rs.IsApprove) === 0)?.Num ?? 0;
        const tab3 = formData?.approves.find(rs => parseInt(rs.IsApprove) === 1)?.Num ?? 0;
        return { tab1, tab2, tab3 };
    }, [formData])

    return (
        <div>
            {openModal && <ModalW05F0008 onClose={onOpenModal} />}
            {openModalApprove && <ModalApproveW05F0008 itemApprove={itemApprove.current}
                onClose={() => {
                    onOpenModalAprrove();
                    loadForm();
                }} />}
            <ActionToolbar allwaysTop title={Config.lang("Danh_sach_phu_luc_hop_dong_ban")}>
                <Button viewType="filled" startIcon="add" color='primary' label={Config.lang("Them")} onClick={onOpenModal} disabled={permission < 1} />
            </ActionToolbar>
            <div className={"hidden"}>{renderFilters()}</div>
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                position={{ my: 'center', of: "root" }}
                visible={loading}
                showIndicator={true}
                shading={true}
                showPane={true}
            />
            <TabContainer
                tabIndex={tab}
            >
                <TabHeader
                    style={{
                        justifyContent: 'space-between'
                    }}
                >
                    <TabItem
                        index={0}
                        onClick={() => setTab(0)}
                        label={Config.lang("Tat_ca") + ' (' + approveTotal.tab1 + ')'}
                    />
                    <TabItem
                        index={1}
                        onClick={() => setTab(1)}
                        label={Config.lang("Chua_duyet") + ' (' + approveTotal.tab2 + ')'}
                    />
                    <TabItem
                        index={2}
                        onClick={() => setTab(2)}
                        label={Config.lang("Da_duyet") + ' (' + approveTotal.tab3 + ')'}
                    />
                </TabHeader>
                {/* {[0, 1, 2].map(rs => (
                    <TabPanel index={rs} key={rs}>
                        <GridTabContent data={formData} onChangePage={onChangePage} onChangePerPage={onChangePerPage}
                            filter={filter.current} permission={permission} onCheck={onCheck} />
                    </TabPanel>
                ))} */}
                <GridTabContent data={formData} onChangePage={onChangePage} onChangePerPage={onChangePerPage}
                    filter={filter.current} permission={permission} onCheck={onCheck}
                    onOpenModalAprrove={onOpenModalAprrove} approvePermission={approvePermission} />
            </TabContainer>
        </div>
    );
}

export default W05F0008;
